import React from 'react';
import PropTypes from 'prop-types';

const DisplayErroredImport = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }
  return (
    <ul className="space-y-0.5">
      {errors.map((error) => (
        <li key={error} className="list-disc text-left">
          {error}
        </li>
      ))}
    </ul>
  );
};

DisplayErroredImport.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DisplayErroredImport;
